module.exports = __webpack_public_path__ + "67fce75c5b90d8a127248095434803d4.obj";